import type { NavigateFunction } from 'react-router-dom';

/**
 * Same-origin paths use React Router; other origins use a full assign.
 */
export function navigateToUrl(url: string, navigate: NavigateFunction): void {
  try {
    const target = new URL(url, window.location.href);
    if (target.origin === window.location.origin) {
      navigate(`${target.pathname}${target.search}${target.hash}`);
      return;
    }
  } catch {
    // Fall through to assign.
  }
  window.location.assign(url);
}
